module.exports = __webpack_public_path__ + "static/media/sale3.671caf0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/sale3.png
// module id = 91
// module chunks = 0